import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue"
import NavItem from "@/components/layout/NavItem.vue"
import LogoSvg from "@/components/widgets/icons/LogoSvg.vue"
import { useAuth } from "@/store/auth/useAuth"
import { useUtilities } from "@/hooks/useUtilities"
import { PermissionEnum } from "@/gql"


export default /*#__PURE__*/_defineComponent({
  __name: 'CoreTeamNav',
  setup(__props) {

const { can } = useAuth()

const { collapseDrawer } = useUtilities()

const policy = computed(() => {
  return {
    canManageTalent: can(PermissionEnum.TalentTeam),
  }
})

return { __sfc: true,can, collapseDrawer, policy, NavItem, LogoSvg, PermissionEnum }
}

})